import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText
	},
	body: {
		fontSize: 14,
		padding: '5px 10px',
		overflowX: 'visible !important'
	}
}))(TableCell);

export default StyledTableCell;
